import type { operations } from '@/types/schemas/api.main';
import { GET, setParams } from '../../_http';
type controller = operations['BrokerRetrieveApplicationDraftController_get'];

export type BrokerRetrieveApplicationDraftQuery = controller['parameters']['query'];
export type BrokerRetrieveApplicationDraftResponse = controller['responses']['200']['content']['application/json'];
export type BrokerRetrieveApplicationDraftDto =
  controller['responses']['200']['content']['application/json']['applicationDraft'];

export const retrieveBrokerApplicationDraft = GET(
  '/brokers/applications-draft/retrieve-application-draft',
  setParams<BrokerRetrieveApplicationDraftQuery>,
)<BrokerRetrieveApplicationDraftResponse>;
